import React from 'react';
import { Link } from 'react-router-dom';
import pageAssets from '../../../../data/pageAssets';
import AppImage from '../../../common/media/AppImage';

const HomeProductSelectionSection = ({ intro, productSelection }) => (
    <section id="product-selection" className="product-selection-section-new">
        <div className="container">
            <header className="home-intro">
                <div className="section-subtitle">{intro.productsSubtitle}</div>
                <h1 className="home-intro-title">
                    {intro.titlePrefix} <span>{intro.titleHighlight}</span> {intro.titleLine2}
                </h1>
                <p className="home-intro-description">{intro.description}</p>
                <p className="home-intro-proof">{intro.socialProof}</p>
            </header>
            <div className="selection-grid-new">
                {productSelection.cards.map((card) => (
                    <article key={card.key} className={`selection-card-premium ${card.key}`}>
                        <Link to={card.learnRoute} className="card-image-main" tabIndex="-1" aria-hidden="true">
                            <AppImage src={pageAssets[card.imageKey]} alt={card.imageAlt} />
                        </Link>
                        <div className="card-body">
                            <span className="card-label">{card.label}</span>
                            <h2>{card.titlePrefix} <span>{card.titleHighlight}</span></h2>
                            <div className="feature-pill-list">
                                {card.pills.map((pill) => <span key={pill} className="pill">{pill}</span>)}
                            </div>
                            <p>{card.description}</p>
                            <div className="card-action-btns">
                                <Link to={card.learnRoute} className="btn btn-primary">{card.learnLabel}</Link>
                                <Link to={card.orderRoute} className="link-text">{card.orderLabel} &rarr;</Link>
                            </div>
                        </div>
                    </article>
                ))}
            </div>
        </div>
    </section>
);

export default HomeProductSelectionSection;
